"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UIBaseElement = void 0;
class UIBaseElement {
    constructor(domEl) {
        this._domEl = domEl;
    }
    // Get dom element
    get domEl() {
        return this._domEl;
    }
    // Set dom element
    set domEl(domEl) {
        this._domEl = domEl;
    }
    // Append child
    addChild(child) {
        this._domEl.appendChild(child.domEl);
        return this;
    }
    // Remove child
    removeChild(child) {
        this._domEl.removeChild(child.domEl);
        return this;
    }
    // Remove all childs
    clear() {
        while (this._domEl.children.length) {
            if (!this._domEl.lastChild) {
                throw new Error("Last child is null");
            }
            this._domEl.removeChild(this._domEl.lastChild);
        }
    }
    // Set id
    setId(id) {
        this._domEl.id = id;
        return this;
    }
    // Get id
    getId() {
        return this._domEl.id;
    }
    // Set class name
    setClass(name) {
        this._domEl.className = name;
        return this;
    }
    // Add clas to list
    addClass(name) {
        this._domEl.classList.add(name);
        return this;
    }
    // Remove class from list
    removeClass(name) {
        this._domEl.classList.remove(name);
        return this;
    }
    // Set styles
    setStyle(styles) {
        for (const [key, value] of Object.entries(styles)) {
            this._domEl.style[key] = value;
        }
        return this;
    }
    // Set text
    setTextContent(value) {
        this._domEl.textContent = value;
        return this;
    }
    // Set inner html
    setInnerHTML(value) {
        this._domEl.innerHTML = value;
        return this;
    }
    // Get child index
    getIndexOfChild(element) {
        return Array.prototype.indexOf.call(this._domEl.children, element.dom);
    }
    querySelector(query) {
        return this._domEl.querySelector(query);
    }
    // Set event
    setEvent(event, eventHandler) {
        this.domEl.addEventListener(event, eventHandler, false);
        return this;
    }
    // Remove event
    removeEvent(event, eventHandler) {
        this.domEl.removeEventListener(event, eventHandler, false);
        return this;
    }
    // Add attribute
    addAttribute(key, value) {
        this.domEl.setAttribute(key, value);
        return this;
    }
    // Remove attribute
    removeAttribute(key) {
        this.domEl.removeAttribute(key);
        return this;
    }
    // Set display
    setDisplay(name) {
        this.domEl.style.display = name;
        return this;
    }
}
exports.UIBaseElement = UIBaseElement;
